import * as React from 'react';
import { CaseListingResultOrInfo } from 'app/area/case-report/case-listing/components/case-listing-result-or-info';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { caseListingTranslation } from 'app/area/case-report/case-listing/constants';
import { HeaderVisibilityConfiguration } from 'app/components';
import { FavouriteDefinition, RenderMode } from 'app/types-shared';
import { PrimaryActionComponentFactory } from 'app/area/case-report/case-listing/types';
import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import { useCaseListingEvents, useSelectors } from 'app/area/case-report/case-listing/hooks';

interface CaseListingProps {
  workingDefinition: FavouriteDefinition;
  report?: number;
}

export interface CaseListingExternalProps {
  headerVisibilityConfiguration?: HeaderVisibilityConfiguration;
  windowAsScrollableAncestor?: boolean;
  requestedRenderMode?: RenderMode;
  hideLoadResults?: boolean;
  hideNumberOfHits?: boolean;
  primaryActionComponentFactory?: PrimaryActionComponentFactory;
  autoExecute?: boolean;  
  translation: any;
  fetching: boolean;
  results: CaseResult[];
  totalNumberOfResults: number;
  executeFailed?: JSX.Element;
}

export const CaseListing = ({
  workingDefinition,
  primaryActionComponentFactory,
  windowAsScrollableAncestor,
  headerVisibilityConfiguration,
  autoExecute,
  requestedRenderMode,
  fetching,
  results,
  totalNumberOfResults,
  executeFailed
}: CaseListingProps & CaseListingExternalProps) => {

  const translation = useTranslation(STATE.caseListing, caseListingTranslation);
  
  const { renderMode } = useSelectors();
  const {
    fetchMoreData
  } = useCaseListingEvents(
    workingDefinition, 
    primaryActionComponentFactory, 
    requestedRenderMode,
    fetching,
    autoExecute,
    results,
    totalNumberOfResults
  );

  if (executeFailed) {
    return executeFailed;
  }

  return (
    <CaseListingResultOrInfo
      translation={translation}
      autoExecute={autoExecute}
      results={results}
      totalNumberOfResults={totalNumberOfResults}
      fetching={fetching}      
      fetchMoreData={fetchMoreData}
      renderMode={renderMode}
      primaryActionComponentFactory={primaryActionComponentFactory}
      windowAsScrollableAncestor={windowAsScrollableAncestor}
      headerVisibilityConfiguration={headerVisibilityConfiguration} />
  );
};
